import { PropTypes } from 'prop-types';
import React from 'react';

import StinkNewsletter from '../Newsletter/StinkNewsletter';
import HomepageHeroLatelyMostRead from './HomepageHeroLatelyMostRead';
import HomepageMosaic from './HomepageMosaic';

const HomepageHeroLatelyBottom = ({ mosaic, mosaicQuote, mostRead }) => {
  return (
    <div data-module-id="homepage_hero_lately_bottom">
      <div className="homepage-grid-desktop-container mb-14 lg:mb-18">
        <div className="lg:col-span-7">
          <div className="px-6 lg:px-0 sm:px-10">
            <StinkNewsletter />
          </div>
          <HomepageHeroLatelyMostRead mostRead={mostRead} />
        </div>
        <div className="lg:col-span-13">
          <HomepageMosaic mosaic={mosaic} mosaicQuote={mosaicQuote} />
        </div>
      </div>
    </div>
  );
};

HomepageHeroLatelyBottom.propTypes = {
  mosaic: PropTypes.array,
  mosaicQuote: PropTypes.object,
  mostRead: PropTypes.array,
};

export default HomepageHeroLatelyBottom;
